module.exports = __webpack_public_path__ + "img/source_sw-con02.e6857c32.png";